module.exports = __webpack_public_path__ + "img/10no-one.74b76eab.png";